const timeoutPromise = (timeout = 0, f = () => {}) =>
  new Promise((res) => {
    setTimeout(() => {
      res(f());
    }, timeout);
  });

export default timeoutPromise;
